export const PaymentMethods = {
    SQUARE: "square",
    STRIPE: "stripe",
};